export const NOT_FOUND = 404;
export const BAD_REQUEST = 400;
export const FORBIDDEN = 409;
export const UNAUTHORIZED = 401;
export const UNAUTHORIZED_NAME = "Unauthorized";
export const RESOURCE_NOT_FOUND_NAME = "ResourceNotFound";
export const API_URL = "/api";
